module.exports = __webpack_public_path__ + "static/img/children9.f8c39a9f.jpg";